import { ReportProblem } from '@mui/icons-material';
import { Box, Typography, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PREFIX = 'errorPage';

const classes = {
  button: `${PREFIX}-button`,
  errorIcon: `${PREFIX}-erroricon`,
  warningIcon: `${PREFIX}-warningicon`,
  title: `${PREFIX}-title`,
  subtitle: `${PREFIX}-subtitle`,
};
const StyledGrid = styled('div')(({ theme }) => ({
  [`& .${classes.button}`]: {
    padding: '8px 22px',
    verticalAlign: 'middle',
    display: 'inline-flex',
    gap: '8px',
  },
  [`& .${classes.warningIcon}`]: {
    fontSize: '72px',
    color: theme.palette.warning.main,
    marginBottom: '32px',
  },
  [`& .${classes.title}`]: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '20px',
    fontWeight: 500,
  },
  [`& .${classes.subtitle}`]: {
    color: 'rgba(0, 0, 0, 0.6)',
  },
}));

const WOrderErrorPage = props => {
  const { t } = useTranslation('workOrdersTable');
  const { title, subtitle, button } = classes;
  const {
    iconLabel = <ReportProblem className={classes.warningIcon} />,
    titleLabel = t('detail.error404Labels.titleLabel'),
    subtitleLabel = t('detail.error404Labels.subTitleLabel'),
    buttonLabel = t('detail.error404Labels.buttonLabel'),
    onClickError,
  } = props;
  return (
    <StyledGrid>
      <Box
        p={2}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        sx={{
          height: 'calc(100vh - 400px)',
        }}
      >
        {iconLabel}
        <Typography className={title}>{titleLabel}</Typography>
        <Typography className={subtitle}>{subtitleLabel}</Typography>
        <Box mt={4}>
          <Button
            variant="contained"
            size="small"
            className={button}
            onClick={onClickError}
          >
            {buttonLabel}
          </Button>
        </Box>
      </Box>
    </StyledGrid>
  );
};

export default WOrderErrorPage;
